import LegacyRouteRedirect from '@/components/navigation/LegacyRouteRedirect';
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const BookingsView = lazy(() => import('./components/BookingsView'));

const ReturnsView = lazy(() => import('./components/ReturnsView'));

/**
 * The Bookings routes.
 */
const bookingsRoutes: FuseRouteItemType[] = [
	{
		path: 'bookings',
		children: [
			{ index: true, element: <LegacyRouteRedirect to="/bookings/active" /> },
			{
				path: 'active',
				element: <BookingsView />
			},
			{
				path: 'returned',
				element: <ReturnsView />
			},
			{
				path: 'active/:bookingId',
				element: <BookingsView />
			}
		]
	}
];

export default bookingsRoutes;
